import { render, staticRenderFns } from "./Subhead.vue?vue&type=template&id=577ebffa&scoped=true&"
import script from "./Subhead.vue?vue&type=script&lang=js&"
export * from "./Subhead.vue?vue&type=script&lang=js&"
import style0 from "./Subhead.vue?vue&type=style&index=0&id=577ebffa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577ebffa",
  null
  
)

export default component.exports